export default {
  file: 'File',
  label_add: 'Add',
  label_new: 'New',
  label_save: 'Save',
  label_edit: 'Edit',
  label_close: 'Close',
  label_create: 'Create',
  label_submit: 'Submit',
  loader: 'Please Wait..',
  label_search: 'Search',
  label_update: 'Update',
  label_cancel: 'Cancel',
  label_change: 'Change',
  label_select: 'Select',
  label_delete: 'Delete',
  label_access: 'Access',
  label_disable: 'Disable',
  label_active: 'Activate',
  label_duplicate: 'Duplicate',
  label_confirm: 'Confirm',
  label_apply: 'Apply',
  download: 'Download',
  download_csv: 'Download as CSV',
  download_pdf: 'Download as PDF',
  send_csv: 'Send as CSV',
  placeholder_date: 'MM-DD-YYYY',
  otp_verify_loader: 'Verifying OTP...',
  delete_modal_header: 'Are you sure ?',
  placeholder_password: 'Enter Password',
  otp_generate_loader: 'Generating OTP...',
  mandatory_label: 'Field marked with * is mandatory',
  placeholder_externalurl: 'example. https://www.google.com',
  delete_modal_content:
    'Do you really want to permanently delete this record ?',
  welcome_text: 'Welcome to Admin Center',
  good_eve_text: 'Good Evening,',
  external_link: 'External Link',
  document: 'Document',
  pages: 'Pages',
  category1: 'Category 1',
  category2: 'Category 2',
  category3: 'Category 3',
  category4: 'Category 4',
  external: 'External',
  internal: 'Internal',
  privacy_policy: 'Privacy Policy',
  termsof_use: 'Terms of Use',
  block1: 'Block 1',
  block2: 'Block 2',
  block3: 'Block 3',
  request_successful: 'Request was completed successfully.',
  request_unsuccessful: 'Request was not completed.',

  admin: {
    reports_setting: {
      configure_report_title: 'Configure Report Settings',
      select_format: 'Select File Format',
      save: 'SAVE',
      email_notification:
        'Send E-mail notification for successful or failed report generation',
      days: 'Days',
      report_expiry: 'Duration for Report Expiry',
    },

    dashboard_modules: {
      members: {
        module: 'Members',
        //manage_member: 'Manage Member',  // Changed as per JMP-5189
        manage_member: 'View Member Details',
        configure_reg: 'Configure Registration',
        reset_email: 'Reset Email/Username',
        reset_password: 'Reset Password',
        portal_settings: 'Portal Settings',
        manage_member_content:
          'View Coverage Information, Personal Information, Claim Information, Documents, and View or Download ID Cards of Members and Dependents.',
        configure_reg_content:
          'Define Registration rules and set up the Registration process for both Members and Dependents when they are registering on the Member Portal.',
        reset_email_content:
          'Set up Reset Email or User ID feature (when a Member clicks on Forgot Email) on the Member Portal.',
        reset_password_content:
          'Set up Reset Password feature (when a Member clicks on Forgot Password) on the Member Portal.',
        portal_settings_content:
          'View/Edit preference settings for all Users by allowing them to Suppress Fields and select their preferred Date Format.',
      },
      member_experience: {
        module: 'Member Experience',
        branding: 'Apply Branding',
        resources: 'Manage Resources',
        contacts: 'Manage Contacts',
        links: 'Configure Links',
        pages: 'Configure Pages',
        social_media: 'Configure Social Media',
        apply_branding_content:
          'Elevate the visual appeal and brand experience of both the portals. The customizations will be visible to all Users across all devices.',
        manage_resource_content:
          'You can create Resources to publish it to your respective Members and Dependents in the Resources widget on the Member Portal.',
        manage_contact_content:
          'Update contact information that appears in Connect With Us in the footer of Member Portal. This information can be customized for specific Blocks of Business and Employers.',
        configure_links_content:
          'Create system specific links that appear in footer blocks. This information can be customized for specific Blocks of Business and Employers.',
        configure_pages_content:
          'Design simple HTML Pages which will display relevant information to Members and Dependents using the Member Portal.',
        configure_social_content:
          'Configure Links to various Social Media pages including Facebook, Twitter, LinkedIn, and YouTube. The Links will appear in footer.',
      },
      admin_users: {
        module: 'Admin Users',
        users: 'Manage Users',
        create_user: 'Create User',
        permission_group: 'Permission Group',
        enrollment_rules: 'Manage Enrollment Rules',
        security_settings: 'Security Settings',
        price_compare: 'Estimate Cost',
        admin_configuration_module: 'Admin Configuration',
        admin_search_claims_module: 'Search Claims',
        admin_documents_Tail: 'Messages and Documents',
        admin_approval_Tail: 'Review Request(s)',
        self_account_unlock_configuration: 'Self Account Unlock',
        manage_help_document: 'Manage Help Documents',
        security_setting_content:
          'Set up Password Policy and One Time Password feature for all Users to ensure security of their respective accounts.',
        estimate_cost_content:
          'Estimate Cost(s) for any Member and their Dependents who fall under your Affiliated BLOB, Employer, and Location.',
        manage_user_content:
          'Handle everything related to Admin User management (Insurers, Employers, and Brokers). View User account information, (if authorized) create new Users or update account information.',
        create_user_content:
          '(If authorized) Create a new User, set up their respective roles, and Add or Remove Blocks of Business, Employer, Location, and Permission Groups.',
        permission_group_content:
          '(If authorized) Create and define the roles that each Insurer or Employer or Broker will have and assign them with various permissions that are available in the system.',
        enrollment_rules_content:
          'Define a set of eligibility and notification rules for Enrollment.',
        admin_configuration_content:
          'Choose to show only specific Networks in the Portal and allow end Users to see benefits as per Network or Tiers in their plan.',
        admin_search_claims_content:
          'Search for Claims using different criteria to view Claim details.',
        generate_reports:
          'Select Reports that you need, define criteria and generate a wide range of real-time Reports.',
        report_setting:
          '(If authorized) Configure report settings by defining file format, duration for report expiry, and email notifications for successful or failed report generation.',
        admin_documents_Tail_content:
          'View Upload documents for any Member or Dependent or Upload a document on behalf of them.You can also view Messages and Updates/Remainders.',
        admin_approval_Tail_content:
          'View, Approve, Deny or Transfer any request(s) assigned to you for approval.',
        manage_help_document_content:
          'Manage Help Center User Guide documents and the Glossary for different personas (Member, Doctors/Physicians, Broker, Provider, Insurers) as well as update, upload and download these documents from the portal',
      },
      reports: {
        module: 'Reports',
        tile_text: 'Reports',
        report_setting: 'Report Setting',
        renerate_reports_module: 'Report Settings',
      },
    },
    pages: {
      resources: {
        link: 'Link',
        page: 'Page',
        module: 'Resources',
        resource: 'Resource',
        document: 'Document',
        _new: 'Add New Resource',
        _edit: 'Modify Resource',
        _view: 'View Resource',
        content_type: 'Content Type',
        external_link: 'External Link',
        duplicate: 'Duplicate Resource',
        resource_title: 'Resource Title',
        content_ref: 'Content Reference',
        resource_des: ' Resource Description',
        loading_resources: 'Loading Resources..',
        resource_category: 'Resource Categories',
        resource_group_title: 'Resource Group Title',
        choose_contenttype: 'Choose the Content Type',
        choose_resource_number: 'Choose Resource Group Number',
        dashboard_info: 'This would appear on Member Portal Dashboard ',
        placeholder_search: 'Search by Resource Title or Resource Group',
        services_info: 'This would appear when Member mouseovers the services',
        contenttype_info: 'Select the Content Type to get more details',
      },
      links: {
        link: 'Link',
        module: 'Links',
        _edit: 'Modify Link',
        _view: 'View Link',
        link_type: 'Link Type',
        _new: 'Create New Link',
        link_block: 'Link Block',
        link_title: 'Link Title',
        block_title: 'Block Title',
        choose_block: 'Choose Block',
        external_url: 'External URL',
        select_page: 'Select a page',
        duplicate: 'Duplicate Link',
        configure_link: 'Configure Link',
        content_ref: 'Content Reference',
        loading_links: 'Loading Links..',
        placeholder_search: 'Search by Link Title',
      },
      medialinks: {
        module: 'Configure Social Media & Mobile Setup',
        loading: 'Loading medias..',
      },

      helpcenter: {
        module: 'Help Center',
        user_guide_content:
          'Provides step-by-step guidance for performing various administrative functions including setting up and managing the Member Portal.',
        glossary_content:
          'Provides a better understanding of unfamiliar terms to master the language of health care.',
        download_guide: 'Download User Guide',
        download_glossary: 'Download Glossary',
        user_guide: 'User Guide',
        glossary: 'Glossary',
      },
      contacts: {
        email: 'Email',
        phone1: 'Phone 1',
        phone2: 'Phone 2',
        address: 'Address',
        module: 'Contacts',
        contact: ' New Contact',
        _new: 'Add New Contact',
        _edit: 'Modify Contact',
        _view: 'View Contact',
        description: 'Description',
        creating_new: 'Creating a new contact..',
        updating_contact: ' Updating Contact..',
        loading: 'Loading Contacts..',
      },
      configure_pages: {
        page: ' New Page',
        _edit: 'Edit Page',
        _view: 'View Page',
        _new: 'Create Page',
        page_title: 'Page Title',
        module: 'Configure Pages',
        page_content: 'Page Content',
        loading_pages: 'Loading Pages..',
        loading_content: "Loading Page's Content..",
      },
      email_reset: {
        module: 'Email Reset Setup',
      },
      password_reset: {
        module: 'Password Reset Setup',
      },
      portal_settings: {
        module: 'Portal Settings',
      },
      security_settings: {
        module: 'Security Settings',
      },
      registration: {
        module: 'Configure Registration',
      },
      branding: {
        module: 'Branding',
      },
      admin_configuration: {
        module: 'Admin Configuration',
      },
      manage_help_documents: {
        module: 'Manage Help Documents',
      },
      users: {
        user: 'User',
        _edit: 'Edit User',
        _new: 'Create New User',
        module: 'User Management',
        _duplicate: 'Duplicate User',
        loading_users: 'Loading Users...',
        loading_list: 'Loading User List...',
        user_acc_status: 'User Account Status',
        super_user_help_text: 'Super User Selected',
        loading_user_roles: 'Loading User Roles...',
        placeholder_search: 'Search by Name or Email',
        loading_user_details: 'Loading User Details...',
        insurer_help_text:
          'Insurer selected. Add Block of Business to continue',
        client_help_text:
          'Employer Selected, Kindly add an employer and permission group to continue',
        email_exists_error: 'This email address is already being used',
        super_user_create_error:
          'Only a super user can create a super user account',
        super_user_update_error:
          'Only a super user can update a super user account',
        duplicate_user_hint_text:
          'An Instance of the User has been copied. Enter Personal Information. Other Information like Block of Business, Employer, Location, and Group has been copied and can be changed and saved here.',
        new_user: 'Add User',
      },

      //remove below object once the CreateNewUser folder is removed
      new_users: {
        module: 'Create New User',
      },
      manage_permission_group: {
        search: 'Search Group',
        module: 'Manage Permission Group',
        new_group: 'New Permission Group',
        placeholder_search: 'Search Group Name',
        loading_users_list: 'Loading Users List...',
        rolename_error_msg: 'This Role Name already exists',
        unsaved_changes_msg_title: 'You have unsaved changes',
        loading_permissions_list: 'Loading Permissions List...',
        loading_save_permission_group: 'Saving User Group Permissions',
        loading_permission_group_list: 'Loading Permission Group List...',
        loading_update_permission_group: 'Updating User Group Permissions',
        create_success_msg:
          'A new Permission Group has been created successfully!',
        update_success_msg: 'User Group Permission has updated successfully',
        create_error_msg: 'Error occurred while saving User Group Permissions.',
        update_error_msg:
          'Error occurred while updating User Group Permissions.',
        unsaved_changes_msg_body:
          'You have made some changes to this permission group. Do you want to save changes before leaving this page ?',
        users_list: {
          title: 'Users',
          btn: 'Add Users',
          sub_title: 'with this Permission Group',
        },
        form_label: {
          user_type: 'User Type',
          permissions: 'Permissions',
          permission_group_name: 'Permission Group Name',
          permission_group_description: 'Permission Group Description',
        },
      },

      manage_member: {
        //module: 'Member Management', // Changed as per JMP-5189
        module: 'View Member Details',
        registered: 'Registered',
        registered_member: 'Registered Member',
        all_members: 'All Members',
        loading_list: 'Loading User List...',
        loading_user_details: 'Loading User Details...',
        member_acc_status: 'Member Account Status',
        member_id: 'Member ID',
        dependent_member_id: 'Dependent Member ID',
        member_type: 'Member Type',
        user_type: 'User Type',
        date: 'Created On',
        employer: 'Employer',
        location: 'Location',
        personal_info: 'Personal Information',
        registered_email: 'Registered Email',
        phone: 'Phone',
        alt_email: ' Alternate Email',
        password: 'Password',
        temp_password: 'Temporary Password',
        active_coverages: 'Member Information',
        coverage: 'Coverage',
        claims: 'Claims',
        acc_summary: 'Account Summary',
        id_card: 'ID Card',
        update_reg_email: 'Update Registered Email',
        update_alt_email: 'Update Alternate Email',
        alternate_email: 'Alternate Email',
        change_acc_status: 'Change Member Account Status',
        acc_status: 'Member Account Status',
        change_password: 'Change Password',
        loading_mem_details: ' Loading Member Details...',
        user_status: 'User Status',
        user_status_unchanged: 'User Status is unchanged',
        valid_email: 'Enter a valid email address',
        documents: 'Documents',
        view_profile: 'Profile',
        primary_search: 'Search by Name, ID or Email',
        additional_search: 'Search by Member Details',
        member_search_text: 'Search Member',
        member_additional_search_text:
          'Enter Member details accurately to get the desired result',
        additional_search_fields: {
          member_id: 'Member ID',
          cert_number: 'Cert Number',
          alt_id_1: 'Alt ID 1',
          alt_id_2: 'Alt ID 2',
          first_name: 'First Name',
          last_name: 'Last Name',
          dob: 'DOB',
          ssn: 'SSN',
          home_phone: 'Home Phone',
          email_id: 'Email ID',
        },
        accumulators: 'Accumulators / Benefits',
      },

      price_comparison: {
        page_sub_heading:
          'Estimate cost(s) for any Member and their Dependents who fall under your Affiliated BLOB, Employer, and Location. You can select up to 3 providers to review cost(s).',
        member_container: {
          container_text: 'Service',
          member_dropdown_label: 'Search Member',
          container_labelText: 'Information about member search criteria',
        },
        finalResultTile: {
          patient_responsibility: 'Patient Responsibility',
          plan_pays: 'Plan pays: ',
          billed_amount: '| Billed Amount: ',
          download_details: 'Download Details',
        },
        disclaimer:
          'The information displayed at the time of submission is only an estimate.',
      },

      reports: {
        module: 'Reports',
        refresh_text: 'Refresh',
        generate_report_button_text: 'Generate Report',
        send_button_text: 'SEND SELECTED',
        delete_button_text: 'DELETE',
        generate_report_heading: 'Generate Reports',
      },
      manage_claims: {
        module: 'Search Claims',
      },
      approval: {
        Approvals: 'Approvals',
        tabs: {
          Enrollment: 'Enrollment (Members)',
          Self: 'Self Registration (Providers)',
        },
        tags_request: {
          all: 'ALL REQUESTS',
          pending: 'PENDING REQUESTS',
          approved: 'APPROVED REQUESTS',
          denied: 'DENIED REQUESTS',
          deleted: 'DELETED REQUESTS',
        },
      },
      enrollment_rules: {
        create_rules: {
          title: 'New Enrollment Rule',
          rule_form: {
            rule_name: {
              title: 'Rule Name',
              description:
                'First step to create a rule, or to modify it. Give the rule a descriptive name summarizing the key details (e.g. 2023 Open Enrollment Standard Plans)',
            },
            enrollment_period: {
              title: 'Enrollment Period',
              description:
                'Specify the start and end dates defining the open enrollment period window when participants can sign up for or change current benefit selections.',
              from_label: 'Open Enrollment period From',
              through_label: 'Open Enrollment period Through',
            },
            effective_date: {
              title: 'Benefit Effective Date',
              description:
                'The benefits effective date drives retrieval of benefit plans that align with the designated effective date.',
              date_label: 'Benefit Effective as on',
            },
            benefit_plans: {
              title: 'Benefit Plans',
              description1:
                'The listed plans represent those active on the configured effective date. Check the boxes to include or hide specific benefit plans.',
              description2:
                'Click into any benefit plan to view or edit details like costs, coverages offered, and more.',
            },
            reload_plan_button: 'Fetch / Reload Benefit Plans',
            save_button: 'Save',
          },
        },
      },
    },

    common_user_details: {
      email: 'Email',
      phone: 'Phone',
      status: ' User Account Status',
      password: 'Password',
      lastname: 'Last Name',
      user_type: 'User Type',
      firstname: 'First Name',
      middlename: 'Middle Name',
      alt_email: ' Alternate Email',
      user_status: 'User Status',
      info: 'Personal Information',
      select_user_type: 'Select User Type',
      created_date: 'Created On',
      confirm_email: 'Confirm Email',
      password_rules: 'Password Rules:',
      recent_activity: 'Recent Activity',
      temp_password: 'Temporary Password',
      password_strength: 'Password Strength',
      password_rule4: 'At least 1 number (0-9)',
      password_rule1: 'At least 12 characters long',
      password_rule5: 'At least 1 symbol (Example: ~!@$)',
      user_status_unchanged: 'User Status is unchanged',
      password_rule2: 'At least 1 lower case characters (a-z)',
      password_rule3: ' At least 1 upper case characters (A-Z)',
    },

    permission_group: {
      title: 'Permission Groups',
      remove_group: 'Remove Permission Group',
      remove_group_2: 'Remove',
      module: 'Add Permission Group',
      module_2: 'Add Permission',
      options: 'No Options Available',
    },

    block_of_business: {
      title: 'Block of Business',
      module: 'Block of Businesses',
    },

    employer: {
      module: 'Employer',
    },

    products_and_plans: {
      select_plan: 'Select Plans',
      module: 'Products and Plans',
    },

    duration: {
      module: 'Duration',
      effective_to: 'Effective To',
      effective_from: 'Effective From',
      optional_label:
        '* Below Date fields are optional. You may add Effective From and Effective To date for the eligible links.',
      effectiveDuration: 'Effective Duration',
    },

    toast_messages: {
      creation_unsuccessful: 'Failed to Create',
      updation_unsuccessful: 'Failed to Update',
      deletion_unsuccessful: 'Failed to Delete',
      deletion_successful: 'Deleted Succesfully',
      download_unsuccessful: 'Failed to Download',
      creation_successful: 'Created Successfully',
      updation_successful: 'Updated Successfully',
      duplicate_unsuccessful: 'Failed to Duplicate',
      download_successful: 'Downloaded Successfully',
      duplicate_successful: 'Duplicated Successfully',
    },
  },
  member: {
    pages: {
      helpcenter: {
        module: 'Help Center',
        user_guide_content:
          'Provides step-by-step guidance for performing various administrative functions including setting up and managing the Member Portal.',
        glossary_content:
          'Provides a better understanding of unfamiliar terms to master the language of health care.',
        download_guide: 'Download User Guide',
        download_glossary: 'Download Glossary',
        user_guide: 'User Guide',
        glossary: 'Glossary',
      },
      registration: {
        landing: {
          member_title: "I'm the Member",
          member_sub_title: 'Manage health benefits for you and your family.',
          dependent_title: "I'm a Dependent",
          benefits_title: 'The benefits of registering to our portal',
          benefit_1: 'Manage health benefits for you and your family',
          benefit_2: ' Enjoy Services like claim and view Claims and EOBs',
          benefit_3: 'Get your ID Card information and so much more',
          select_option: 'Select an option to continue',
          describes_you: 'What best describes you?',
        },
        confirm_identity: {
          sub_title: 'How would you like to confirm your identity?',
        },
        registration_info: {
          registration: 'Registration',
          activation_code: 'Enter account Activation Code.',
          activation_title: 'Activation Code',
          activation_msg:
            'Enter a 16 digit code received via your Email, SMS, or Postal Address',
          already_mem: 'Already a Member?',
          login_here: 'Login here.',
          registration_code: 'What is Registration Code?',
          registration_msg1:
            'Your Employer will notify you when you will receive this email and code. Registration code is a 8-16 digit alphanumeric code that looks like 1736SDLI0374. Copy and paste the code from email or text message.',
          registration_msg2:
            'If you have not received a code, please notify your employer and they will coordinate to send you a new code.',
          registration_msg3:
            'For any issues that you may encounter during the registration process, please reach out to your Employer.',
          registration_title: 'Your additional information',
          coverage_info:
            'We found your account, here is your coverage information.',
          info_not_match:
            'Please contact your Health Plan Administrator if your details do not match.',
          introduction: 'Introduction',
          privacy_policy: 'Privacy Policy',
          privacy_policy_disclaimer_1:
            'By clicking accept, you accept to our Privacy Policy.',
          privacy_policy_disclaimer_2:
            'If you leave this page, you will not be able to proceed with registration and no data will be saved in our system.',
          terms_conditions: 'Terms and Conditions',
          terms_conditions_disclaimer_1:
            'By clicking accept, you accept to our Terms and Conditions.',
          terms_conditions_disclaimer_2:
            'If you leave this page, you will not be able to proceed with registration and no data will be saved in our system.',
          accept: 'ACCEPT',
          find_mem_id:
            'Find your Member ID on the front of your ID Card. (Example: 11122233)',
          member_id: 'What is Member ID?',
          enter_mem_id: 'Enter your Member ID',
          otp_sent_msg:
            'To verify your email, we have sent a One Time Password (OTP) to',
          enter_otp: 'Enter One Time Password',
          dual_coverage_info:
            'We have found a record(s). Select the record(s) that you want to link to your account.',
          mail_sent_message:
            'If an account exists for the email you entered, you will receive an email with instructions to continue registration',
        },
      },
      my_profile: {
        module: 'Profile',
        employer: 'Employer',
        dependent: 'Dependent',
        employment: 'Employment',
        module_title_prefix: 'My',
        loading: 'Loading Profile Details...',
        personal_info: {
          member_title: 'Member Details',
          employment_title: 'Employment Details',
        },
        contact_info: {
          phone_and_email_title: 'Phone & Email',
          mailing_address_title: 'Mailing Address',
          residential_address_title: 'Residential Address',
        },
        change_password: {
          title: 'Change Password',
          error_msg: 'Current Password is Incorrect',
          success_msg: 'Your password has been changed',
        },
        change_email: {
          title: 'Registered Email',
          error_msg: 'Error while updating user',
          email_id_prefix: 'Your email address is',
          alternateemail_successtitle:
            'Your Alternate Email ID has changed successfully',
          alternateemail_subtitle: 'Login with your new registered email ID.',
          registeredemail_successtitle:
            'Your Registered Email ID has been changed successfully',
          registeredemail_subtitle:
            'Log in to your account with your new registered emailID.',
          hint_text:
            'Due to security reasons, if you change your registered email address, system will logout and you need to login again using new email address.',
        },
        alternate_email: {
          title: 'Alternate Email',
          error_msg: 'Error while updating user',
          success_msg:
            'Your Alternate email address has been added successfully',
        },
        registered_email: {
          title: 'Registered Email',
        },
        patient_right: {
          hipaa_patient_right: 'HIPAA Patient Right',
          responsible_party_info: 'Responsible Party Information',
          no_data: "Currently you don't have any responsible party",
        },
        eob_preferences: {
          title: 'EOB Preferences',
          content:
            'Maximize convenience by accessing your EOBs online. You can update delivery method with the options below.',
          same_dependent_settings: 'Apply same settings to all my dependents',
          disclaimer:
            'Go green, don’t print, as it is good for the environment.',
        },
        dependent_info: {
          age_suffix: 'years',
          no_data: "You don't have any dependants",
        },
        otp: {
          incorrect_otp: 'OTP is Incorrect',
          footer_question: 'Did not get it?',
          otp_expire_msg: 'The OTP will expire in',
          otp_regenerate_error: 'Failed to re-generate OTP',
          append_header_hint_text: 'Please enter it below.',
          input_field_footer_label: 'Enter OTP sent to you via email',
          prepend_header_hint_text:
            'We have sent a One Time Password (OTP) to the email ',
        },

        labels: {
          age: 'Age',
          zip: 'Zip',
          city: 'City',
          state: 'State',
          title: 'Title',
          county: 'County',
          status: 'Status',
          suffix: 'Suffix',
          gender: 'Gender',
          message: 'Message',
          country: 'Country',
          email_1: 'Email 1',
          email_2: 'Email 2',
          continue: 'Continue',
          location: 'Location',
          dob: 'Date of Birth',
          last_name: 'Last Name',
          new_email: 'New Email',
          otp: 'One Time Password',
          home_phone: 'Home Phone',
          mobile: 'Mobile',
          work_phone: 'Work Phone',
          mobile_phone: 'Mobile Phone',
          start_date: 'Start Date',
          department: 'Department',
          name_and_id: 'Name & ID',
          first_name: 'First Name',
          resend_code: 'Resend code',
          middle_name: 'Middle Name',
          address_1: 'Address Line 1',
          address_2: 'Address Line 2',
          address_3: 'Address Line 3',
          new_password: 'New Password',
          ssn: 'Social Security Number',
          marital_status: 'Marital Status',
          dependent_name: 'Dependent Name',
          change_password: 'Change Password',
          alternate_email: 'Alternate Email',
          confirm_password: 'Confirm Password',
          current_password: 'Current Password',
          blob_id_name: 'Block of Business ID-Name',
          rel_to_insured: 'Relationship to Insured',
          employee_authorization: 'Allow Employee to view my information?',
          responsible_party_authorization:
            'Allow Responsbile Party to view my information?',
          alt_id1: 'Alternate ID 1',
          alt_id2: 'Alternate ID 2',
          patientid: 'Certificate Number',
          dependent_member_id: 'Dependent Member ID',
          no_of_dependents: 'Number of Dependents',
          race: 'Race/ Ethnicity',
          contact_information: 'Contact Information',
          Email: 'Email',
          Extn: 'Extn',
          Street_Address: 'Street Address',
          appartment: 'Appartment / Suit',
          update_address: 'UPDATE ADDRESS',
        },
      },
      account_details: {
        label_search: 'Search',
        label_transaction_types: 'Transaction Types',
        reset_filter: 'Reset Filters',
        available_balance: 'Available Balance',
        spent_amt: 'Spent Amount:',
        benefit_label: 'Benefit Plan',
        plandetail_: 'Coverage Status',
        coverage_period: 'Coverage Period',
        effective_from: 'Coverage Effective From',
        coverage_level: 'Coverage Level',
        employer_contribution: 'Employer Contribution',
        self_contribution: 'Self Contribution',
        coverage_history: 'View Coverage History',
        account: 'Account:',
        benefit_year: 'Benefit Year:',
        module_title_prefix1: 'My',
        account_title: 'Account',
        coverage_status: 'Coverage Status:',
      },
      claims: {
        reset_filter: 'Reset Filters',
        duration: 'Duration',
        claim_type: 'Claim Type',
        member_claims: 'Member',
        option_available: 'No Options Available',
        back_account_list: 'Back to Account list',
        back_claims_list: 'Back to Claims list',
        label_claim: 'Claim',
        label_claimed_for: 'Claimed for:',
        label_service_date: 'Service Date:',
        claims_service_title: 'Services for this Claim',
        module_title_prefix3: 'My',
        claims_title: 'Claims',
        filter: 'FILTER',
        processed_on: 'Processed on:',
        patient_card: 'Patient Responsibility to Provider',
        service_providedby: 'Service Provided by',
        claims_status: 'Claim Status:',
        payment_date: 'Finalized Date:',
        download: 'Download EOB',
        patient_responsibility: 'Patient Resposiblity',
        total_bill_amount: 'Total Billed Amount',
        amount_paid: 'Amount Paid',
        paid_on: 'Paid on:',
      },
      coverages: {
        waiting_time: 'Waiting Period',
        coverage_year: 'Benefit Year',
        coverage_period: 'Benefit Period',
        total_paid: 'Total paid upto date',
        coverage_benefits_availed: 'Benefits Used',
        coverage_detail_period: 'Coverage Period:',
        coverage_detail_benefit: 'Benefit Plan:',
        coverage_detail_status: 'Coverage Status:',
        coverage_detail_insurance: 'Other Insurance:',
        coverage_detail_covered: 'Members Covered:',
        coverage_detail_emp_only: 'Employee Only',
        covered_service_cost: 'Covered Services and Costs',
        plandetail_benefit_label: 'Benefit Plan',
        plandetail_coverage_status: 'Coverage Status',
        plandetail_coverage_period: 'Coverage Period',
        plandetail_effective_from: 'Coverage Effective From',
        plandetail_coverage_level: 'Coverage Level',
        plandetail_other_insurance: 'Other Insurance',
        mem_covered: 'Members Covered',
        coverage_history: 'View Coverage History',
        download_doc: 'Download Plan Documents',
        coverage_plan: 'This plan has',
        applied: 'Applied',
        coverage_remaining: 'Remaining',
        coverage_maximum: 'Maximum',
        coverage_unlimited: 'Unlimited',
        coverage_type: 'Coverage Type',
        option_available: 'No Options Available',
        coverage_for: 'Coverage for',
        modify: 'MODIFY',
        coverage_network: 'Network',
        module_title_prefix: 'My',
        coverage_title: 'Coverage',
        termination_reason: 'Termination Reason',
      },
    },

    dashboard: {
      coverage: {
        coverage_para:
          'You do not have Vision Coverage. Do you want to explore optoins?',
        deductible_remaining: 'Deductible Remaining',
        remaining: 'Remaining Out-of-Pocket',
        plan: 'Plan:',
        view_coverage_details: 'View Coverage Details',
        find_coverage_options: 'Find Coverage Options',
        this_plan: 'This plan has',
        no_deductible: 'No Deductible',
        unlimited: 'Unlimited',
        out_of_pocket: 'Out-of-pocket',
        coverage_status: 'Coverage Status',
        view_coverage_for: 'View Coverage For',
        deductible: 'Deductible',
        coverage_options: 'FIND COVERAGE OPTIONS',
        statusfor: 'Coverage Status For:',
        coverage_details: 'Coverage Details',
        view: 'View',
      },

      findcare: {
        title: 'Find Care',
        view_all: 'View All',
        find_provider: 'FIND A PROVIDER',
      },

      talon: {
        title: 'Cost Estimator Tool',
        description:
          'to view and compare cost estimate for the services you need.',
      },

      notification: {
        messages: 'Messages',
        view_all: 'View All',
        sort_by: 'Sort by:',
        most_recent: 'Most Recent',
      },

      resource: {
        resource: 'Resources',
        title: 'View All Resources',
      },

      spending: {
        spending_error: 'Unable to retreive account summary',
        summary_title: 'Spending Summary',
        available_balance: 'Available Balance',
        spent_amt: 'Spent Amount:',
        show_details: 'Show Details',
        summary_para:
          'Contributions to Health Savings Account are limited to a maximum amount each year. Balance in HSA account can cover the allowed Medical, Dental, and Vision costs for you, your spouse and your Dependents.',
        no_data_found: 'No Data Found',
        try_again:
          'Couldn’t find any data for this section. Please try again or contact our support team.',
        something_wrong: 'Something went wrong',
        error_encountered:
          'We encountered an error while trying to connect to the server. Please try again.',
        claims_status: 'Claims Status',
      },

      price_compare: {
        heading: 'Cost Estimator Tool',
        price_compare_button: 'ESTIMATE COST',
        price_info_para1:
          'Are you wondering what a procedure will cost? Get an estimate for common procedures from one of our locations near you.',
        price_info_para2:
          'You can only view estimates for some physicians and advanced practice providers who are employed by your health insurance company. Estimates for other providers, who are not employed by your health insurance company, are not available.',
      },

      dashboard_workinprogress: {
        title: 'Work in progress',
        message:
          'This feature will be added very soon to our member portal. Meanwhile, you can continue using other features here.',
        go_to_dashboard: 'GO TO DASHBOARD',
      },

      dashboard_page: {
        mem_id: 'Member ID:',
        view_profile: 'VIEW PROFILE',
        welcome_msg: 'Welcome to Member Dashboard Portal',
      },
    },

    email_recovery: {
      personal_info: {
        content: 'We just need a few details from you to get started.',
        page_info: 'What best describes you?',
        member: 'Member',
        dependent: 'Dependent',
        return_to_login: 'Return to Login',
        continue: 'Continue',
        valid_member_info: 'Validating Member Information',
        registered_email: 'Find Registered Email',
      },
      registered_id: 'Your registered email id is...',
      login_with: 'Login using the above email',
      login: 'LOGIN AGAIN',
      did_you_know: 'Did you know?',
      paragraph:
        'If you are physically tired, the best thing to do is exercise as it will give you more energy than sitting.',
      please_enter: 'Please enter it below.',
    },

    password_recovery: {
      check_details: 'Enter the below information to validate your account.',
      valid_user: 'Validating user information',
      otp_verify_email:
        'To verify your email, we have sent a One Time Password (OTP) to',
      password_success: 'Your password has been',
      success_msg: 'successfully changed',
      mail_sent_message: 'If an account exists you will receive an email.',
      new_password: 'Login using the new password',
      login_button: 'LOGIN AGAIN',
      did_you_know: 'Did you know?',
      paragraph:
        'If you are physically tired, the best thing to do is exercise as it will give you more energy than sitting.',
      registered_email: 'Registered Email',
      return_to_login: 'Return to Login',
      continue: 'Continue',
      loading_user: 'Loading User Details',
      title:
        'To reset password, please enter the email you have used to register. To validate your account, you may be asked for additional information.',
      reset_password: 'Reset Password',
      progress_title: "Let's secure your account",
      update_password: 'Updating user information',
    },

    common_labels: {
      email: 'Email',
      phone: 'Phone',
      status: ' User Account Status',
      password: 'Password',
      lastname: 'Last Name',
      user_type: 'User Type',
      firstname: 'First Name',
      middlename: 'Middle Name',
      alt_email: ' Alternate Email',
      user_status: 'User Status',
      info: 'Personal Information',
      created_date: 'Created Date',
      confirm_email: 'Confirm Email',
      password_rules: 'Password Rules:',
      recent_activity: 'Recent Activity',
      temp_password: 'Temporary Password',
      password_strength: 'Password Strength',
      password_rule4: 'At least 1 number (0-9)',
      password_rule1: 'At least 12 characters long',
      password_rule5: 'At least 1 symbol (Example: ~!@$)',
      user_status_unchanged: 'User Status is unchanged',
      password_rule2: 'At least 1 lower case characters (a-z)',
      password_rule3: ' At least 1 upper case characters (A-Z)',
      date_of_birth: 'Date of Birth',
      mobile_phone: 'Mobile Phone',
      ssn: 'SSN',
      phone_no: 'Phone Number',
      plan: 'Plan',
      member: 'Member',
      alternate_email: 'Alternative Email',
      relationship: 'Relationship',
      postal_code: 'Postal Code',
      medicare_id: 'Medicare ID',
      alt_id2: 'Alternate ID 2',
      alt_id1: 'Alternate ID 1',
      member_id: 'Member ID',
      certificate_num: 'Certificate Number',
      plan_id: 'Plan ID',
      client_name: 'Client Name',
      client_id: 'Client ID',
      state: 'State',
      city: 'City',
      address_2: 'Address Line #2',
      address_1: 'Address Line #1',
      continue: 'Continue',
      otp_verify_loader: 'Verifying OTP',
      otp_generate_loader: 'Generating OTP',
      resend_code: 'Resend code.',
      did_not_get: 'Did not get it?',
      otp_information: 'Enter OTP sent to you via email',
      otp_label: 'One Time Password',
      text: "We've sent a One Time Password (OTP) to the email",
      new_password: 'New Password',
      confirm_password: 'Confirm Password',
      continue: 'Continue',
      account_setup: 'Account Setup',
      check_user: 'checking if user already exist',
      validating_user: 'Validating user info',
      login_here: 'Login here.',
      already_mem: 'Already a Member?',
      generate_otp: 'Generating OTP...',
      verify_otp: 'Verifying OTP...',
      submitted_for_review:
        'Your request has been successfully submitted for review.',
      notification_msg:
        'You will be notified once your request has been approved.',
      notification_subtext:
        'Contact your Plan Administrator for further queries.',
      success: 'You have been successfully registered.',
      thank_you: 'Thank you for using Member Portal.',
      login: 'LOGIN',
      did_you_know: 'Did you know?',
      card_msg:
        'If you are physically tired, the best thing to do is exercise as it will give you more energy than sitting.',
      privacy_policy: 'Privacy Policy',
      terms_and_condition: 'Terms and Conditions',
      accept: 'ACCEPT',
      firstname_here: 'First Name Here',
      residential_address: 'Residential Address',
      mailing_address: 'Mailing Address',
      employment_information: 'Employment Information',
      employer_name_id: 'Employer Name & ID',
      block_business_id: 'Block of Business ID-Name',
      department: 'Department',
      employment_start_date: 'Employment Start Date',
      location: 'Location',
      otp_forgot_email:
        'If an account exists for the email you entered, you will receive an email with instructions to reset your password. Please check your inbox and spam folder',
    },

    login: {
      carousel_note1: 'Health Plans now offer Alternative Care options',
      carousel_para1:
        'Many plans now expand their alternative care options to offer unlimited acupuncture coverage with no prior authorization or referrals required.',
      carousel_note2: 'Don’t have an account yet?',
      carousel_para2:
        "We're here to help. It is easy to register and you will get access to tools, tips,and programs to help you reach your healthiest you",
      carousel_para2_1: '',
      carousel_para2_2: '',
      carousel_note3: 'With your online account you can',
      carousel_para3:
        'View your Benefits, view and print your ID Cards, check your Claims, view your Spending Account details, find a Doctor, and much more…',
      username: 'Username/Email',
      password: 'Password',
      login: 'LOGIN',
      register: 'REGISTER',
      account: 'Do Not Have an Account?',
      register_account: 'Register for a new account.',
      forgot_pass: 'Forgot Password',
      forgot_email: 'Forgot Email',
      loading: 'Logging you in',
      work_progress: 'Work in progress',
      forgotpass_notes:
        'This feature will be added very soon to our member portal. Meanwhile, you can continue using other features here.',
      go_back: 'GO TO LOGIN',
      coverage_status: 'Coverage Status',
      mobile_app: 'Get the Mobile Application',
      mobile_note:
        'For accessing your account, downloading ID Cards, finding in-network provider and tracking claim status, our Mobile app is packed with features to manage your insurance easier. Download it now!',
      sign_in: 'Sign in to continue',
      two_step: '2-Step Verification',
      loading_admin: 'Loading Admin Configuration...',
      generate_otp: 'Generating OTP...',
      otp_para:
        'To verify your email, we have sent a One Time Password (OTP)  to',
      otp_title: 'Enter One Time Password',
      otp_expire: 'Enter OTP sent to you via email.',
      did_not_get: 'Did not get it?',
      return_to_login: 'Return to Login',
      resend_code: 'Resend code.',
      continue: 'Continue',
    },

    logout: {
      logout_msg:
        'Thank you for using Member Portal. Your secure session is now closed. We recommend you to close the browser for your security.',
      login: 'LOGIN',
      do_you_know: 'Did you know?',
      message:
        'If you are physically tired, the best thing to do is exercise as it will give you more energy than sitting.',
      session_logout: 'You have been logged out due to inactivity.',
      session_logout_msg:
        'You have been logged off after a period of inactivity that exceeded the limit set by the site administrator.',
    },
    registeredemail_Updated: {
      updated_msg: 'Your registered email ID is updated to',
      message:
        'You are logged out of the system. Log in again using your new registered email ID.',
    },

    resource: {
      resource_title: 'Resources',
      no_records: 'No Records Found',
    },

    sidenavbar: {
      mem_id: 'Member ID:',
      my_profile: 'My Profile',
      logout: 'Logout',
      affiliate_account: 'Affiliate Account',
    },

    payment: {
      back_to_claims: 'Back to Claim',
      payment: 'Payment',
      amt_to_pay: 'Amount to Pay',
      payment_method: 'Select a Payment Method',
      back_info: 'Enter Bank Account information',
      Account_holder: 'Account Holder Name',
      account_num: 'Account Number',
      routing_num: 'Routing Number',
      account_type: 'Account type',
      save_payment: 'Save payment method',
      pay_now: 'PAY NOW',
      credit_debit_info: 'Enter Credit /Debit Card information',
      name_on_card: 'Name on Card',
      credit_debit_num: 'Credit / Debit Card number',
      valid_thru: 'Valid Thru',
      cvv: 'CVV',
      payment_for_claim: 'Payment for Claim',
      claimed_for: 'Claimed for:',
      provider: 'Provider:',
      service_date: 'Service Date:',
      processed_on: 'Processed on:',
      balance_total: 'Balance Total:',
    },

    download_idcard: {
      download_title: 'Download',
      id_cards: 'ID Cards',
      download_info: 'Lost your ID card?',
      download_info_1: 'Need additional copies for a dependent on your plan?',
      download_info_2:
        'Click “Download PDF” or “Send Email” for additional cards.',
      download_info1:
        ' ID Card requests made by a dependent will generate with the name of the primary policyholder.',
      download_img_info:
        'This image is for illustration purpose only. Remember: ID Cards are for identification purposes only; they do not guarantee eligibility or payment of your claim.',
      download_pdf: 'Download PDF',
      email: 'Send Email',
      need_replacement: 'Need replacement cards?',
      replacement_card_info:
        'If you have lost your insurance cards or need addtional copies of Insurance ID cards, you can order new ID cards here. Please allow up to 2 weeks for it to arrive at the address we have on our records. To send it to a different address,',
      contact_us: 'contact us.',
      request_newcard: 'Request new ID Card',
      no_id_card:
        'No ID Card found for this user. Please note that it can take up to 7 days after your effective date for your card to be mailed and posted in your portal.',
      id_card_pages: 'Download ID Cards Page',
      id_card_500_status:
        'ID Card request could not be processed at the moment! Contact your Administrator for further information.',
      new_idcard_successful:
        '"Your request for a new ID Card has been submitted successfully!',
    },

    price_comparison: {
      heading_text_compare: 'Estimate',
      heading_text_price: 'Cost',
      zip: 'Enter location e.g. Zip Code, City, Area',
      accessibility_page_info: 'Estimate Cost Page',
      page_sub_heading:
        'To estimate cost(s) for a service, start by selecting services. Then select providers you wish to avail the service from. You can select up to 3 providers to review cost(s).',
      learn_more: 'Learn more',
      bottom_compare_panel_heading_text: 'Estimate Cost',
      provider_settings: ' + More Provider Settings',
      doctor: '  Doctor Type',
      doctor_name: "Doctor's Name or NPI",
      facility: '  Facility Type',
      facility_name: ' Facility Name or Tax ID',
      remove_provider: '(-) Remove Provider Settings',
      search: 'Search',
      doctor_label: 'Doctor',
      label_facility: 'Enter a specialty or type of Facility',
      label_facility_name: 'Enter Facility Name or Tax ID',
      facility_label_tab: 'Facility',
      label_placeholder_doctor: 'Enter a specialty or type of doctor',
      label_placeholder_doctor_name: "Enter Doctor's Name or NPI",
      member_search_placeholder: 'Search by Name, Email or Member ID',
      procedure_container: {
        accessibility_container_info:
          'Information About Services search criteria',
        container_text: 'Service',
        container_textPostfix: '(s)',

        procedure_dropdown_label: 'Service(s) for',
        procedure_dropdown_labelText: 'filter dropdown, Service for',

        health_procedure_dropdown_label: 'Health Service',
        health_procedure_dropdown_label_postfix: '(s)',
        health_procedure_dropdown_placeholder:
          'Enter any health service(s) keyword',
        health_procedure_dropdown_labelText: 'filter dropdown, Health service',
        health_procedure_hintText: 'Example :Cataract (CPT® 66984)',
        more_options: 'More Options',
        more_options_label: 'Billed Amount',
        more_options_placeholder: 'Enter the maximum value for this service',
        amount_tooltip_title: 'What is billed amount',
        amount_tooltip_content:
          'The billed cost is the dollar amount that the provider charged on the service line for the service rendered.',
        billed_amount: 'Billed Amount:',

        //Serach Result Page
        service_for_label: 'Service For : ',
        health_procedure_label: 'Service Type : ',
      },
      provider_container: {
        accessibility_container_info:
          'Information About Provider search criteria',
        container_text: 'Provider',

        location_dropdown_label: 'Location',
        location_dropdown_labelText: 'search provider by location',

        type_or_specialty_dropdown_label: 'Type or Specialty',
        type_or_specialty_dropdown_labelText:
          'filter dropdown, Type or Specialty',

        name_dropdown_label: 'Name',

        type_or_specialty_placeholder: 'Enter a Specialty or Type of Provider',
        name_placeholder: "Enter Provider's Name ",

        networks_dropdown_label: 'Network ',
        networks_dropdown_labelTier: 'Network Tier ',
        networks_dropdown_labelText: 'filter dropdown, Network',
        networks_dropdown_labelTextTier: 'filter dropdown, Network Tier',

        serachBy_labelText: 'Search : ',
        by_type_radio_ariaLabel: 'filter, By type',
        by_type_radio_text: 'By Type',
        by_name_radio_ariaLabel: 'filter, By name',
        by_name_radio_text: 'By Name',

        add_filter_btn_text: '+ Add Filter',
        add_filter_btn_ariaLabel: 'Click to add more filters',

        //Search Result Page
        location_label: 'Location : ',
        network_label: 'Network : ',
        by_doctor_name: "Doctor's Name or NPI",
        by_doctor_specialty: 'Doctor Type',

        search_by_label: 'Search By : ',
        distance_label: 'Distance : ',

        accept_new_patients_label: 'Accept New Patients : ',
        language_label: 'Language : ',

        filter_text: 'Filter',
        billed_amount: 'Billed Amount',
        reset_filters: 'Reset Filters',
        show_all_filters: 'ALL FILTER',
        covered_cost: 'Covered Cost',
        slider_minimum_label: 'Minimum Cost',
        slider_maximun_label: 'Maximum Cost',
      },
      member_container: {
        container_text: 'Member',
      },

      recent_table: {
        request_id: 'Request ID : ',
        service_for: 'Service(s) for :',
        providers: 'Providers :',
        not_found_error_heading: 'No Recent Request Found!',
        not_found_error_message: 'We could not find any recent request.',
        delete_model_header: 'Delete Request',
        delete_modal_body_content:
          'Are you sure you want to delete this request? This cannot be undone.',
      },

      search_btn_text: 'SEARCH',
      search_btn_ariaLabel:
        'Click to search prividers based on the filter selection and compare the price.',

      //Search Result Page
      modify_btn_label: 'Modify Search',
      result_card_distance: 'Distance',
      show_cost_button: 'SHOW COST',

      //Main Comparison Screen
      another_search_btn_label: 'Try Another Search',
      another_search_btn_ariaLabel: 'Click to try another search',
      request_id_label: 'Your Request ID ',
      disclaimer:
        'The information displayed at the time of submission is only an estimate.',

      finalResultTile: {
        in_network_label: 'In-Network',
        out_of_network_label: 'Out-of-Network',
        experience_postfix_text: 'years in Practice',
        you_may_owe: 'You may owe',
        your_plan_pays: 'Your plan pays',
        pricing_details: 'Cost Break Up',
        total: 'Total',
        covered: 'Covered',
        copay: 'Copay',
        plan_pay: 'Plan pays',
        disallowed: 'Disallowed',
        co_insurance: 'Co Insurance',
        other: 'Additional Patient Responsibility',
        deductible: 'Deductible',
        deductibleRemaining: 'Deductible Met/Remaining',
        out_of_pocket: 'Out-of-pocket',
        applied: 'Applied',
        remaining: 'Remaining',
        maximum: 'Maximum',
        billed_amount: '| Billed Amount: ',
      },
    },

    upload_document: {
      send: 'Send',
      document: 'Document(s)',
      view_all: 'View All',
      title: 'Title',
      type: 'Type',
      reference_number: 'Claim Number',
      comment: 'Comment',
      cancel: 'Cancel',
      send: 'Send',
      senddocumentfor: 'Send Documents for',
    },

    messaging: {
      main_title: 'Messages and Documents',
    },
  },

  header: {
    title: 'MEMBER PORTAL',
    my_profile: 'My Profile',
    logout: 'Logout',
  },

  landing_page: {
    main_heading: 'A Best Health',
    insurance_experience: 'Insurance Experience',
    normal_text:
      'Redefining Health Insurance with a unique, user-friendly web portal packed with top-notch features.',
    who_i_am: 'Who am I',
    mem_dep: 'Member/Dependent',
    member_note:
      'As a Member/Dependent, you can get access to tools, tips, and programs to help you reach your healthiest you.',
    mem_admin: 'Employer/Admin',
    admin_note:
      'From configuring settings to viewing and editing Permission Groups, you can perform numerous functions, enjoy different privileges, and have multiple roles to play.',
    mobile_app: 'Get the Mobile Application',
    mobile_note:
      'For accessing your account, downloading ID Cards, finding in-network provider and tracking claim status, our Mobile app is packed with features to manage your insurance easier. Download it now!',
  },

  find_provider: {
    affiliations: 'Affiliations',
    hospitals_and_facilities: ' Hospitals and Facilities',
    show_affiliated_doctors: 'See Affiliated Doctors',
    affiliated_doctors: 'Affiliated Doctors',
    data_not_available: 'Data Not Available',

    awards_and_recognitions: 'Awards and Recognitions',
    website: 'Website',
    age: 'Age',
    language_spoken: 'Languages Spoken',
    email: 'Email',
    provider_information: 'Provider Information',
    phone: 'Phone',
    provider_address: 'Provider Address',
    provider_billing_address: 'Office Billing Address',
    provider_service_address: 'Service Address',
    provider_mailing_address: 'Mailing Address',
    change_provider_location: 'Change Provider Location',
    directions: 'Get Directions',
    accepting_new_patients: 'Accepting New Patients',
    in_network: 'In-Network',
    not: 'Not',
    out_of_network: 'Out-of-Network',
    patient_satisfaction: 'Patient Satisfaction',
    networks: 'Networks',
    professional_details: 'Professional Details',
    specialties: 'Specialties',
    medical_school_education: 'Medical School Education',
    medical_group: 'Medical Group',
    board_certification: 'Board Certifications',
    experience: 'Experience',
    license_type: 'License Type',
    license_number: 'License Number',
    national_provider_id: 'National Provider ID (NPI)',
    same_day_appointment: 'Same Day Appointment',
    facilities_location: 'Facilities at the Location',
    office_hours: 'Office Hours',
    placeholder: 'Placeholder',
    gender: 'Gender',
    providers: 'Providers',
    distance: 'Distance',
    provider_services: 'Provider Services',
    location: 'Location',
    contact_information: 'Contact Information',
    credentials: 'Credentials',
    education: 'Education',
    search_provider: 'Search Provider',
    sort_by: 'Sort By',
    filter: 'FILTER',
    reset_filters: 'Reset Filters',
    show_all_filters: 'Show ALL FILTERS',
    other_service_locations: 'Other Service Locations',
    hospital_details: 'Facility Details',
    practice_type: 'Practice Type',
    tax_id: 'Tax ID',
    fax: 'Fax',
    facility_type: 'Facility Type',
    see_all_affiliated_doctors: 'See all Affiliated Doctors',
    facilities: 'Facilities',
    address: 'Address',
    speciality: 'Speciality',
    placeholder_discription:
      'If you are physically tired, the best thing to do is exercise as it will give you more energy than sitting.',
    search_results: 'Your Search Results for',
    first_name: 'FIRST NAME',
    last_name: 'LAST NAME',
    email_c: 'EMAIL',
    phone_c: 'PHONE',
    find: 'Find',
    provider: 'Provider',
    locations: 'Locations',
    provider_heading: 'Duffaut, Calvin J, MD',
    provider_details: 'Family Practice, Internal Medicine',
    provider_num: 'Phone: (719) 632-5700',
  },
  modals: {
    downloadplan_modal: {
      module: 'Plan Documents',
      error_msg:
        'Sorry, a plan document has not been published or cannot be found. Please contact your health plan administrator if you have questions about your benefits.',
    },
  },

  data_not_found: {
    no_results: 'No results found',
    could_not_match: 'We couldn’t find a match for',
    another_search: 'Please try another search',
    search_tips: 'Search Tips',
    spelling_keywords: 'Check the spelling of your keywords',
    try_broader: 'Try a broader search criteria',
    fewer_keywords:
      'Try using fewer keywords. Example: street name without house number.',
  },

  long_time_error: {
    main_error_msg: 'Your request is taking longer than expected!',
    please_try_again: 'Please try again later.',
    below_para:
      'Your pending request (with all details) can be found in Price Comparison home screen. To view, click on ',
  },
};
